import { ForwardedRef, forwardRef } from 'react';
import { clsx } from '@team/clsx';
import { Interactive } from './components/interactive';
import { NonInteractive } from './components/non-interactive';
import { isInteractive, prepareProps } from './model';
import { Props } from './types';
import css from './style.module.css';

/**
 * Базовый интерактивный (кликабельный) корневой компонент
 *
 * @private
 */
export const Entry = forwardRef(function Clickable<T>(
  { baseClassName, ...props }: Props<T>,
  forwardedRef: ForwardedRef<T>
) {
  const Component = isInteractive(props) ? Interactive : NonInteractive;
  const commonProps = prepareProps(props);
  const baseClassNameValue = clsx(baseClassName, css.root);

  return (
    <Component
      {...commonProps}
      {...props}
      baseClassName={baseClassNameValue}
      ref={forwardedRef}
    />
  );
});
